/** The main call to action on the sign-in and sign-up screens: PackPilot green, softly lit. */
export const authButtonSx = {
  minHeight: 52,
  borderRadius: '12px',
  fontSize: '1rem',
  fontWeight: 650,
  color: '#fff',
  background: 'linear-gradient(180deg, #0B7464 0%, #05473E 100%)',
  boxShadow:
    '0 1px 0 rgba(255,255,255,0.18) inset, 0 0 0 1px rgba(5,71,62,0.9), 0 10px 24px -10px rgba(5,71,62,0.7)',
  transition: 'transform 120ms, box-shadow 160ms, filter 160ms',
  '&:hover': {
    background: 'linear-gradient(180deg, #0B7464 0%, #05473E 100%)',
    filter: 'brightness(1.08)',
    boxShadow:
      '0 1px 0 rgba(255,255,255,0.18) inset, 0 0 0 1px rgba(5,71,62,0.9), 0 14px 30px -10px rgba(5,71,62,0.8)',
  },
  '&:active': { transform: 'translateY(1px)' },
  '&.Mui-disabled': { color: 'rgba(255,255,255,0.7)', opacity: 0.7 },
} as const;

/** The quieter second choice under the main button. */
export const authSecondarySx = {
  minHeight: 50,
  borderRadius: '12px',
  fontWeight: 600,
  borderColor: 'divider',
  color: 'text.primary',
  bgcolor: 'background.paper',
  '&:hover': { borderColor: 'text.disabled', bgcolor: 'background.paper' },
} as const;
